import { zodResolver } from '@hookform/resolvers/zod'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import InnerBox from '@repo/ui/inner-box'
import Typography from '@repo/ui/typography'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { TripProviderTypes } from '../../../lib/types/models/trip-provider/trip-provider'
import { BaseFormProps, NullableTransformer } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { createStringSchema } from '../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ValidationButtons from '../../elements/validation-buttons'

const formSchema: ZodType<NullableTransformer<TripProviderTypes.Input>> = z.object({
  companyName: createStringSchema('NOM de la société'),
  comments: createStringSchema('Commentaires').optional().nullable()
})

const TripProviderForm = ({
  defaultValues,
  ...validationButtonProps
}: BaseFormProps<TripProviderTypes.Input>) => {
  const form = useForm<TripProviderTypes.Input>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <InnerBox className={'p-4 rounded-2xl flex flex-col gap-3'}>
          <Typography variant={'text'} color={tailwindColors.primary.DEFAULT}>
            Prestataire voyage
          </Typography>

          <FormField
            control={form.control}
            name={'companyName'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledInput {...field} label={'NOM de la société'} type="text" required />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name={'comments'}
            render={({ field }) => (
              <FormItem className={'flex-1'}>
                <FormControl>
                  <ControlledInput {...field} label={'Commentaire'} type="textarea" />
                </FormControl>
              </FormItem>
            )}
          />
        </InnerBox>

        <ValidationButtons {...validationButtonProps} />
      </form>
    </Form>
  )
}

export default TripProviderForm
